import React, { useEffect } from 'react';
import RetailOrderGrid from '../../../features/cfi/retail-order-grid/components/RetailOrderGrid';
import { useTitle } from "../../../contexts/title";

export default function RetailOrdersPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Retail Orders')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<RetailOrderGrid
					vanityOrders={false}
					backOrders={false}
				/>
			</div>
		</React.Fragment>
	)
} 
